import React from 'react'
import { func, string, bool } from 'prop-types'
import classnames from 'classnames'
import svgs from './icon-set'

const Icon = ({ onClick, svg, isSelected = false, withoutHover = false, withoutFill = false }) => {
  const addClasses = classnames('svg-icon', {
    'svg-icon--selected': isSelected,
    'svg-icon--no-hover': withoutHover,
    [`svg-icon--${svg}`]: svg,
    'svg-icon--without-fill': withoutFill
  })
  return svgs[svg]
    ? (<svg viewBox={svgs[svg].viewBox}
      className={addClasses}
      onClick={isSelected ? undefined : onClick}
      xmlns='http://www.w3.org/2000/svg'>
      {svgs[svg].svg}
    </svg>)
    : null
}

Icon.propTypes = {
  onClick: func,
  svg: string,
  isSelected: bool,
  withoutFill: bool,
  withoutHover: bool
}

export default React.memo(Icon)